
import { useContext, ref, defineComponent } from '@nuxtjs/composition-api'
import { useJsonLd } from '~/composables/useJsonLd'
import { Pages } from '~/assets/ts/pages'
import Maintenance from '~/components/Maintenance.vue'

export default defineComponent({
  head: {
    link: [
      {
        rel: 'preload',
        as: 'image',
        href: require('~/assets/img/index/individual_weddingrings@2x.webp'),
        fetchpriority: 'high',
      },
    ],
  },
  setup() {
    const {
      app: { i18n, router },
    } = useContext()

    let pageRoute = '' as string | null | undefined
    let pageName = '' as string
    let pageStr = '' as string

    const PagesHelper = new Pages()

    pageRoute = PagesHelper.getPageRoute(router)
    pageName = PagesHelper.getPageName(pageRoute)
    pageStr = PagesHelper.getPageStr(pageName)

    const isMaintenanceVisible = ref(false)

    const onMaintenanceClose = () => {
      isMaintenanceVisible.value = false
    }

    // Inject Organization JSON-LD (index page) via reusable composable
    useJsonLd(['index_Organization'])

    return {
      i18n,
      pageRoute,
      pageStr,
      pageName,
      isMaintenanceVisible,
      onMaintenanceClose,
    }
  },
})
